module.exports = __webpack_public_path__ + "img/space-station.c9f4ba63.svg";